module.exports = __webpack_public_path__ + "img/vip-24-hours.dea0a9bd.png";